import { gql } from "@apollo/client";
import { MENU_FIELDS, POSTS_ARCHIVE_FIELDS } from "./post.esm.js";
const AUTHOR_FIELDS = gql`
    fragment AuthorFields on CMSUser {
        id
        name
        description
        link
        avatar
        jobTitle
        head: yoast_head
        socialLinks {
            x
            linkedin
            youtube
        }
        expertise
    }
`;
const AUTHOR_QUERY = gql`
    ${MENU_FIELDS}
    ${AUTHOR_FIELDS}
    ${POSTS_ARCHIVE_FIELDS}
    query AuthorQuery(
        $site: CMSSite
        $id: ID!
        $idType: CMSIDType = ID
        $authorPostsType: CMSPostTypeEnum = POST
        $authorPostsPage: String
        $authorPostsPerPage: String
        $authorPostsOrder: CMSPostOrder
        $authorPostsOrderBy: CMSPostOrderBy
        $authorPostsSearch: String
        $authorPostsTaxonomies: [CMSTaxonomyInput]
        $withSettings: Boolean!
    ) {
        cmsSettings(site: $site) @include(if: $withSettings) {
            menu {
                ...MenuFields
            }
        }
        cmsAuthor(site: $site, id: $id, idType: $idType) {
            user {
                ...AuthorFields
            }
            posts(
                post_type: $authorPostsType
                page: $authorPostsPage
                per_page: $authorPostsPerPage
                order: $authorPostsOrder
                orderby: $authorPostsOrderBy
                search: $authorPostsSearch
                taxonomies: $authorPostsTaxonomies
            ) {
                total
                pages
                posts {
                    ...ArchiveFields
                }
            }
        }
    }
`;
export {
  AUTHOR_FIELDS,
  AUTHOR_QUERY
};
